import React, { Component } from 'react';
import './style.scss';
import { connect } from 'react-redux'
import { setPresentationSlide } from '../../../../actions';
import classNames from 'classnames';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ReactDOM from 'react-dom'
import { Checkbox } from 'antd';

class Item extends Component {
  state = {maxHeight: 0}
  contentRef = React.createRef();
  renderImage = (item) => {
    var img = new Image();
    img.onload = () => {
      if(this.props.setLoadImg){
        this.props.setLoadImg();
      }
    };
    img.src = item.src;
    return <div className="ItemImage" style={{backgroundImage: `url(${item.src})`}}></div>
  }


  renderQuestion = (item) => {

    const text = item.question.question.replace(/<[^>]*>/g, '');
    if(!text){
      let regex = /<img.*?src="(.*?)"/;
      let src = regex.exec( item.question.question )[1];
      return <div className="ItemQuestion">
        <img src={src} />
      </div>
    }

    return <div className="ItemQuestion">
      {text.substring(0, 120)}{text.replace(/<[^>]*>/g, '').length > 120 ? '...' : ''}
    </div>
  }

  componentDidMount = () => {
    const el = ReactDOM.findDOMNode(this);  
    if(el){
      this.contentRef.current.style.height = el.clientHeight + 'px';
      this.contentRef.current.style.paddingTop = 0;
    }
  };
  

  render() {
    const {item, slide, index, selected_slides, onSelectedSlide} = this.props;

    return (
      <Draggable draggableId={'slide-'+ item.id} index={index}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            className="ItemTmp"
          >
            <div className="Item" ref={this.contentRef}>
              <div className='count-slider'>#{index + 1}</div>
              <div className="checkbox-item">
                <Checkbox 
                  onChange={() => {
                    onSelectedSlide(selected_slides.includes(item.id) ? selected_slides.filter(id => item.id != id) : [...selected_slides, item.id])
                  }} 
                  checked={selected_slides.includes(item.id)} 
                />
              </div>
              
              <div {...provided.dragHandleProps}  className={classNames("item_content", {active: slide && slide.id == item.id})} onClick={() => {this.props.setPresentationSlide(item)}}>
                {item.type == "image" && this.renderImage(item)}
                {item.type == "question" && this.renderQuestion(item)}
              </div>
            </div>
          </div>
        )}
        </Draggable>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  slide: state.presentation.slide
})

const mapDispatchToProps = {
  setPresentationSlide
}

export default connect(mapStateToProps, mapDispatchToProps)(Item)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentation/components/Sliders/components/Item/index.jsx